<template>
  <div v-if="isVisible" 
  
  class="render-name-of-question">
    <div
      :class="aligmentCss"
      class="name-of-question text-size-12"
      style="overflow-wrap: break-word;"
    >
      {{ questionLable }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'RenderNameOfQuestion',
  props: {
    poll: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    isLimitReached: {
      type: Boolean,
      default: false,
    },
    isCnetered: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    aligmentCss() {
      if( this.isCnetered ) {
        return 'justify-content-center'
      }
      return 'justify-content-end'      
    },
    isVisible() {
      if (this.value > 0) return true;
      if (this.value == 0 && !this.isLimitReached) return true;
      return false;
    },
    questionLable() {
      if (this.poll.choice_config) {
        return this.poll.choice_config.nameOfQuestion;
      }
      return '';
    },
  },
};
</script>
<style scoped>
.name-of-question, .render-name-of-question {
  width: 100%;
  display: flex;
  align-self: stretch;

}
</style>
